import React from 'react'

import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { useTheme } from '@mui/material/styles'

interface ResponsiveButtonProps {
  icon: React.ReactElement
  label: string
  onClick?: () => void
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top'
  tooltipText: string
  variant?: 'contained' | 'outlined' | 'text'
}

const ResponsiveButton: React.FC<ResponsiveButtonProps> = ({
  icon,
  label,
  onClick,
  placement = 'bottom',
  tooltipText,
  variant = 'text',
}) => {
  const theme = useTheme()

  return (
    <React.Fragment>
      <Button
        onClick={onClick}
        startIcon={icon}
        sx={{
          [theme.breakpoints.down('lg')]: { display: 'none' },
          [theme.breakpoints.up('lg')]: { display: 'inline-flex' },
        }}
        title={tooltipText}
        variant={variant}
      >
        {label}
      </Button>
      <Tooltip
        describeChild={true}
        placement={placement}
        sx={{ display: { xs: 'inline-flex', lg: 'none' } }}
        title={tooltipText}
      >
        <IconButton onClick={onClick}>{icon}</IconButton>
      </Tooltip>
    </React.Fragment>
  )
}

export default ResponsiveButton
